<template>
  <div class="inline-block text-2xl font-bold text-sky-600">
    <div class="flex items-center gap-[0.35rem]">
      <div>
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style></style>
